import { useParams } from 'react-router';

import { useQuery } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { useRequestListagem } from 'hooks/useRequestListagem';
import { StepMenuProps } from 'pages/compra/configuracao-pedido/types';

/**
 * Hook responsável por consultar o estado de salvamento dos steps do menu
 * e retornar os dados para o componente.
 */
export function useQueryConfigPedidoSteps() {
    const requestListagem = useRequestListagem();
    const { id } = useParams();

    return useQuery<StepMenuProps[]>({
        queryKey: ['config-pedido-steps', id],
        queryFn: () =>
            requestListagem({
                url: '/gestao/configpedidostep',
                sort: [{ property: 'idConfigPedido', direction: 'DESC' }],
                filter: [{ property: 'idConfigPedido', operator: 'eq', value: id }],
            }).then((data) => data.data.data),
        enabled: Boolean(id),
        onError: () =>
            enqueueSnackbar('Ocorreu um erro ao carregar as informações de salvamento do menu', {
                variant: 'error',
            }),
    });
}
